import { render, staticRenderFns } from "./TeamSwitcher.vue?vue&type=template&id=55def4cc&"
import script from "./TeamSwitcher.vue?vue&type=script&lang=js&"
export * from "./TeamSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports